module.exports = __webpack_public_path__ + "img/heart-box.b854f2e7.png";